import FieldEditor from "editor/FieldEditor";
import ConfirmModal from "modal/ConfirmModal";
import uuid from "uuid";


class ContentAdminEditor extends FieldEditor {

    /**
     * @abstract
     * @return Array
     */
    static get_name() {
        throw new TypeError('Content Admin Editor must override "get_name" method');
    }

    getSettings() {
        return this.value.settings;
    }

    update() {
        Object.keys(this.editors).forEach((name) => {
            this.editors[name].destroy();
        });
        this.editors = {};

        let $el = (
            eotwJSXFactory('div', {class: "admin-content-field"}, [
                eotwJSXFactory('div', {className: "admin-content-field__header js-header"}, [
                    eotwJSXFactory('strong', null, [this.getSettingValue('name')]),
                    eotwJSXFactory('em', null, [" - ", this.getSettingValue('slug')]),
                    eotwJSXFactory('small', null, [" - ", this.constructor.get_name()]),
                    eotwJSXFactory('button', {type: "button", class: "admin-content-field__toggle"}, [
                        eotwJSXFactory('div', {class: "admin-content-field__toggle__icon"}).html("<svg><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='" + window.CONFIG.adminBuildUrl + "base/icons.svg#arrow-down'></use></svg>")
                    ])
                ])
            ])
        );
        if (this.open) {
            $el.find("strong").html(eotwJSXFactory('input', {type: "text", class: "admin-editor admin-editor--text admin-content-field__name-editor js-name-editor", value: this.getSettingValue('name'), name: "name"}));
            $el.addClass("admin-content-field--open").append(this.getSettingsElement())
        }
        this.$element.html($el);
    }

    create() {
        this.uuid = uuid.v4();
        this.editors = {};
        this.open = false;

        this.setValue({});

        const me = this;
        this.$element.on("click", '.js-header', (e) => {
            if (!$(e.target).is("input")) {
                this.open = !this.open;
                this.update();
                return false;
            }
        }).on("change keypress blur", ".js-name-editor", function () {
            me.setSettingValue('name', $(this).val());
        })
    }

    getValue() {
        return $.extend(true, {}, this.value, {
            type: this.getInputType(),
            uuid: this.uuid
        });
    }

    setValue(val) {
        if ('object' !== typeof val.settings || $.isArray(val.settings)) val.settings = {};
        this.value = val;
        this.update();
    }

    getSettingValue(name) {
        if (ContentAdminEditor.SPECIAL_SETTINGS.indexOf(name) !== -1) {
            return this.value[name];
        } else {
            return this.getSettings()[name];
        }
    }

    setSettingValue(name, value) {
        if (ContentAdminEditor.SPECIAL_SETTINGS.indexOf(name) !== -1) {
            this.value[name] = value;
        } else {
            this.getSettings()[name] = value;
        }
    }

    getSettingsElement() {
        let $loader = (
            eotwJSXFactory('div', {class: "admin-loader-wrap admin-loader-wrap--center"}, [
                eotwJSXFactory('div', {class: "admin-loader"})
            ])
        );
        let $el = (
            eotwJSXFactory('div', {class: "admin-content-field__settings admin-content-field__settings--loading admin-form__row admin-form__row--col-wrap"}, [
                $loader
            ])
        );
        let $left = eotwJSXFactory('div', {class: "admin-form__col admin-form__col--half"});
        let $right = eotwJSXFactory('div', {class: "admin-form__col admin-form__col--half"});
        $el.append([$left, $right]).append(
            eotwJSXFactory('div', {class: "admin-form__submitrow"}, [
                eotwJSXFactory('button', {type: "button", class: "admin-btn admin-btn--submit"}, ["Okay"]).on('click', () => {
                    this.open = false;
                    this.update();
                }),
                eotwJSXFactory('button', {type: "button", class: "admin-btn admin-btn--cancel"}, ["Remove"]).on('click', () => ConfirmModal.confirm('Are you sure you want to remove this field?').then(() => this.emit('remove')))
            ])
        );

        Promise.resolve(this.getSettingsOptions())
            .then((options) => options.map((option) => this.getOptionRow(option)))
            .then((options) => {
                $loader.remove();
                $el.removeClass("admin-content-field__settings--loading");

                for (let i = 0; i < Math.ceil(options.length / 2); i++) {
                    $left.append(options[i * 2]);
                }
                for (let i = 0; i < Math.floor(options.length / 2); i++) {
                    $right.append(options[(i * 2) + 1]);
                }

            }).catch((e) => {
            $el.html(eotwJSXFactory('p', null, [e.message]));
        });


        return $el;
    }

    getOptionRow(option) {
        try {
            let $editor = eotwJSXFactory('div');

            let $option = (
                eotwJSXFactory('div', {class: "admin-form__row"}, [
                    eotwJSXFactory('label', {class: "admin-form__label"}, [option.label || option.name]),

                    $editor
                ])
            );

            if (option.type === 'group') {
                option.children.forEach((child) => {
                    let $childEditor = eotwJSXFactory('div');

                    this.getOptionElement(child, $childEditor);

                    $editor.append($childEditor);
                });
            } else {
                this.getOptionElement(option, $editor);
            }
            return $option;
        } catch (e) {
            console.log(e);
            return eotwJSXFactory('div', {class: "admin-form__row"}, [eotwJSXFactory('strong', null, ["Error: ", e.message])])
        }
    }

    getOptionElement(option, $editor) {
        let editor = FieldEditor.get_editor(option.type, $editor, $.extend({context: "admin-form"}, option));

        editor.on("change", () => {
            this.setSettingValue(option.name, editor.getValue());
        });
        this.editors[option.name] = editor;
        editor.setValue(this.getSettingValue(option.name));
    }

    /**
     * @abstract
     * @return Array
     */
    getSettingsOptions() {
        throw new TypeError('Content Admin Editor must override "getSettingsOptions" method');
    }

    /**
     * @abstract
     * @return Array
     */
    getInputType() {
        throw new TypeError('Content Admin Editor must override "getInputType" method');
    }

}

ContentAdminEditor.SPECIAL_SETTINGS = ['name', 'slug'];

export default ContentAdminEditor;
